import React from 'react';
import Paper from '@material-ui/core/Paper';
import TabsContainer from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import * as lib from '~/dependencies';

export default function Tabs({ tab, onSwitch }) {
  const handleChange = (event, nextTab) => {
    onSwitch(nextTab);
  };

  return (
    <Paper square>
      <TabsContainer
        value={tab}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        onChange={handleChange}
        aria-label="List Open Tickets Tab">
        <Tab index={0} label="List Open Tickets" />
        <Tab index={1} label="New" />
      </TabsContainer>
    </Paper>
  );
}

Tabs.propTypes = {
  tab: lib.PropTypes.number.isRequired,
  onSwitch: lib.PropTypes.func.isRequired,
};
